import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";
import { bubble } from "./shapes";

export function InboxIllustration(props: IllustrationProps) {
  return (
    <Frame {...props}>
      <path d={bubble(46, 26, 68, 34)} fill={c.p500} />
      <circle cx="66" cy="43" r="4" fill={c.n0} />
      <circle cx="80" cy="43" r="4" fill={c.n0} />
      <circle cx="94" cy="43" r="4" fill={c.n0} />
      <path d={bubble(34, 76, 92, 42)} fill={c.n0} stroke={c.p200} strokeWidth="2" />
      <rect x="52" y="88" width="56" height="6" rx="3" fill={c.a300} />
      <rect x="62" y="100" width="36" height="6" rx="3" fill={c.p200} />
    </Frame>
  );
}
